import { render, staticRenderFns } from "./ResetQueryLink.vue?vue&type=template&id=4bd6a1e0"
import script from "./ResetQueryLink.vue?vue&type=script&lang=js"
export * from "./ResetQueryLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports